// empty strings '' adds empty div to the dom to separate controls
// and to always have 2px border
export const fieldGroups: any = [
  ['sho', 'inv', 'des', 'tle', 'ext', 'asm'],
  ['asc', 'mkt', 'fab'],
  ['abr', 'lab', 'key'],
  ['shp', 'sla', 'uns', 'vmr', 'cap', 'tra', 'ttp', 'ttd'],
];

export const halfSizeFields: any = [
  'sho', 'inv', 'abr', 'lab',
];
